import Repository from "./Repository";

const resource = "usercircle";

export default {
  get(userId, circleId) {
    return Repository.get(
      `${resource}/?user_id=${userId}&circle_id=${circleId}`
    );
  },

  alllist(key_name){
    const key = key_name ? `?keyname=${key_name}` : "";
    return Repository.get(`/alllistcircle/` + key);
  },

  getCircleByKeyName(keyname){
    return Repository.get(`/circle/?keyname=${keyname}`);
  },

  all(val, id, page, items) {
    const params = val ? `?search=${val}` : "";
    const circleId = id ? `?id=${id}` : "";
    const pageNum = page
      ? val
        ? `&page_num=${page}`
        : `?page_num=${page}`
      : "";
    const itemNum = items ? `&items=${items}` : "";
    if (val) {
      return Repository.get(`/allcircle/${params}${pageNum}${itemNum}`);
      // return Repository.get(`/circlelists/${params}${pageNum}${itemNum}`);
    } else {
      return Repository.get(`/allcircle/${circleId}${pageNum}${itemNum}`);
      // return Repository.get(`/circlelists/${circleId}${pageNum}${itemNum}`);
    }
  },
};



// WEBPACK FOOTER //
// ./src/repositories/circleRepository.js